import BreadcrumbItem from './BreadcrumbItem';

export default BreadcrumbItem;
